import axios from "axios";
import { useStore } from "../../hooks/store";
import { useLocation, useNavigate, useResolvedPath } from "react-router";
import { useEffect } from "react";

export default function InterceptorProvider({ children }) {
  const store = useStore();
  const nav = useNavigate();
  const path = useResolvedPath();
  const { state } = useLocation();
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response.status;

        if (status === 401 || status === 426) {
          localStorage.setItem("prevPath", path.pathname);
          if (state !== null) {
            localStorage.setItem("prevNavState", JSON.stringify(state));
          }
          console.log(localStorage.getItem("prevPath"));
          nav("/login");
          store.setAlert(
            "Сессия прервалась, необходима авторизация",
            "warning",
          );

          return Promise.reject(error);
        }
        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.response.clear();
    };
  }, []);

  return children;
}
